import { inject, Injectable } from '@angular/core';
import { LinkField } from '@prismicio/client';
import { AnalyticsService } from 'analytics';
import { Product, ProductService } from 'product-shared';
import { Promotion } from 'promotion-shared';

@Injectable({ providedIn: 'root' })
export class ProductBoxAnalyticsService {
  private analytics = inject(AnalyticsService);
  private productService = inject(ProductService);

  public trackProductBoxClick(
    product: Product,
    promotion: Promotion,
    ctaLink: LinkField,
    userType: string,
    isNavProduct: boolean
  ) {
    if (this.productService.isLinkToCheckout(ctaLink)) {
      this.analytics.addECommerceEvent('add_to_cart', product, promotion, undefined, userType, {
        sc_offer_type: 'non_deal_purchase',
        sc_offer_tag: 'non_deal_purchase',
      });
    }

    if (product.alternative_link === '/tv-free-signup') {
      this.analytics.customEvent({
        event: 'gtm visitor interaction',
        interaction_name: 'free tv click',
        free_tv_step: 'from tv-free to signup page',
      });
    }

    if (isNavProduct) {
      this.analytics.addToDataLayer({
        event: 'gtm visitor interaction',
        interaction_name: 'mobile nav link click',
        mobile_nav_link_name: `offer - ${product.name}`,
      });
    }
  }
}
